import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { ContextProvider } from './contexts/ContextProvider'
import { AttendancesContextProvider } from './contexts/AttendancesContext';
import { BookingProvider } from "./contexts/BookingContext";
import './index.css'
import './index-mod.css'

import router from './routes/router'

ReactDOM.createRoot(document.getElementById('root')).render(
  <ContextProvider>
    <AttendancesContextProvider>
      <BookingProvider>
        <RouterProvider router={router} />
      </BookingProvider>
    </AttendancesContextProvider>
  </ContextProvider>

)
